import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const useScrollFix = () => {
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const { pathname } = useLocation();

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0; // Scroll to top
    }
  }, [pathname]);

  return scrollRef;
};
